import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { LayoutService } from '@vex/services/layout.service';
import { filter, map, startWith } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { checkRouterChildsData } from '@vex/utils/check-router-childs-data';
import { ConfigService } from '@vex/services/config.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SidebarComponent } from '@vex/components/sidebar/sidebar.component';
import { SignalRService } from '@vex/services/signal-r.service';
import { AuthService } from '@vex/http-service/auth.service';
import { environment } from '@app/../environments/environment';
import { SyncService } from '@vex/http-service/sync.service';
@UntilDestroy()
@Component({
  selector: 'vex-custom-layout',
  templateUrl: './custom-layout.component.html',
  styleUrls: ['./custom-layout.component.scss']
})

export class CustomLayoutComponent implements OnInit {
  sidenavCollapsed$ = this.layoutService.sidenavCollapsed$;
  isFooterVisible$ = this.configService.config$.pipe(map(config => config.footer.visible));
  isDesktop$ = this.layoutService.isDesktop$;
  toolbarShadowEnabled$ = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    startWith(null),
    map(() => checkRouterChildsData(this.router.routerState.root.snapshot, data => data.toolbarShadowEnabled))
  );

  @ViewChild('configpanel', { static: true }) configpanel: SidebarComponent;
  clientName = environment.CLIENT_NAME;
  private lastActivityUpdate = 0;

  constructor(
    public layoutService: LayoutService,
    public signal: SignalRService,
    private configService: ConfigService,
    private authService: AuthService,
    private router: Router,
    private syncService: SyncService
  ) {
    this.authService.handleUserActivity(); 
    this.signal.initialize();
  }

  ngOnInit() {
    // Background sync requests are explicitly isolated from page-request
    // cancellation, so every authenticated shell can reconcile immediately.
    // This also covers route lifecycles where NavigationEnd occurred before the
    // layout's subscription was attached.
    this.resumePlatformData();
    this.layoutService.configpanelOpen$.pipe(
      untilDestroyed(this)
    ).subscribe(open => open ? this.configpanel.open() : this.configpanel.close());
    this.getWorkerUpdates();
    this.signalRUserProfileUpdate();
  }

  /** Resumes or validates the shared browser cache after authenticated startup. */
  private resumePlatformData(): void {
    this.syncService.resumeOnApplicationStart().then(result => {
      if (result.failed.length > 0) {
        console.warn('Platform data startup recovery needs attention for:', result.failed);
      }
    });
  }

  signalRUserProfileUpdate() {
    this.signal.getDataBySignalR('UserProfileUpdate').subscribe((res) => {
      let user = this.authService.getUserProperty('Id');
      if (res && res.UserData && res.UserData.Id == user){
        this.authService.refreshToken();
      }
    });
  }

  getWorkerUpdates() {
    this.signal.getDataBySignalR('WorkerNodeUpdate').subscribe((message) => {
      message['IsRead'] = false;
      this.layoutService.workerMessages.push(message);
      this.layoutService.messageCount.next(this.layoutService.workerMessages.length);
    });
  }

  @HostListener('window:mousemove')
  @HostListener('window:keydown')
  @HostListener('window:click')
  @HostListener('window:touchstart')
  @HostListener('window:scroll')
  @HostListener('window:focus')
  refreshUserState() {
    const now = Date.now();
    if (now - this.lastActivityUpdate < 1000) return;

    // Throttle rather than debounce: continuous mouse/keyboard activity must
    // still publish a heartbeat instead of postponing it indefinitely.
    this.lastActivityUpdate = now;
    this.authService.handleUserActivity();
  }

}
